/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionPromptsControllerFindOneQueryResponse, TemplateQuestionPromptsControllerFindOnePathParams, TemplateQuestionPromptsControllerFindOneQueryParams, TemplateQuestionPromptsControllerFindOne400, TemplateQuestionPromptsControllerFindOne401, TemplateQuestionPromptsControllerFindOne403, TemplateQuestionPromptsControllerFindOne404 } from "../../models/checklistsController/TemplateQuestionPromptsControllerFindOne";

function getTemplateQuestionPromptsControllerFindOneUrl(id: TemplateQuestionPromptsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-template-question-prompts/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist template question prompt by ID
 * {@link /api/v1/checklist-template-question-prompts/:id}
 */
export async function templateQuestionPromptsControllerFindOne(id: TemplateQuestionPromptsControllerFindOnePathParams["id"], params?: TemplateQuestionPromptsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionPromptsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerFindOne400 | TemplateQuestionPromptsControllerFindOne401 | TemplateQuestionPromptsControllerFindOne403 | TemplateQuestionPromptsControllerFindOne404>, unknown>({ method : "GET", url : getTemplateQuestionPromptsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}